// extracted by mini-css-extract-plugin
module.exports = {"Follow__Label":"Follow_Follow__Label__o_QHS","Follow__Item":"Follow_Follow__Item__0g_7b","Follow__Link":"Follow_Follow__Link__Mj3VR","loader":"Follow_loader__pou2P"};